import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import SEO from '../SEO'; // Import the SEO component
import placeholderImage from '../assets/shop/download.jpeg';

// Import images for all cinnamon products
import cinnamonOffCutImage from '../assets/products/05-Ceylon-cinnamon-off-cuts-IMG_7798.jpg';
import cinnamonQuillingsImage from '../assets/shop/Cinnamon-quilings.avif';
import cinnamonH1Image from '../assets/shop/cinnamon-h1-super.jpg';
import cinnamonH2Image from '../assets/shop/LS10102774-02-E.webp';
import cinnamonH2SuperImage from '../assets/shop/cinnamon-h2-super.jpg';
import cinnamonM4Image from '../assets/shop/12m4-1-540x600-1.jpg';
import cinnamonM5Image from '../assets/shop/LS1010E255-01-E.webp';
import cinnamonC4Image from '../assets/shop/C4-Cinnamon-sticks-Side-view.webp';
import cinnamonC5Image from '../assets/shop/images.jpeg';
import cinnamonC5SpecialImage from '../assets/shop/Ceylon-Cinnamon-sticks-C5-Special-grade-quality-1.jpg';
import cinnamonExtraSpecialImage from '../assets/shop/LS1010F11A-06-E.webp';
import cinnamonAlbaImage from '../assets/shop/ALBA-ceylon-cinnamon-sticks.jpg';
import cinnamonLeafOilImage from '../assets/shop/cinnamon-bark-essential-oil-on-600nw-1682221552.webp';
import cinnamonPowderImage from '../assets/shop/Ceyndulgent-Cinnamon-Powder-r2.jpg';

// Import images for all whole spices
import blackPepperImage from '../assets/shop/bdlpktm02n.webp';
import nutmegImage from '../assets/shop/UPPAL-SONS-JAIFAL-NUTMEG-100-SDL631772710-3-d0e36.webp';
import clovesImage from '../assets/shop/A1PjxnKmF+L._AC_UF894,1000_QL80_.jpg';
import maceImage from '../assets/shop/large_Mace.jpg';
import betelNutsImage from '../assets/shop/images (1).jpeg';
import dehydratedGreenPepperImage from '../assets/shop/dehydrated-green-pepper.jpg';
import whitePepperImage from '../assets/shop/SPI047.jpg';
import cloveStemsImage from '../assets/shop/kkkkkkkkk.jpg';
import turmericImage from '../assets/shop/turmeric-history640x360.jpg';

// Import images for all spice powders
import blackPepperPowderImage from '../assets/shop/Ceylon-Organic-Black-Pepper-Powder-offer-Sri-Lanka.webp';
import nutmegPowderImage from '../assets/shop/Ceylon-Spices-Organic-Nutmeg-Powder-Natural-Spices.jpg';
import whitePepperPowderImage from '../assets/shop/White-Pepper-Powder-1.jpg';
import gingerPowderImage from '../assets/shop/large_Ginger Powder.png';
import clovePowderImage from '../assets/shop/Clove-Powder.webp';
import turmericPowderImage from '../assets/shop/turmeric.webp';
import chiliPowderImage from '../assets/shop/large_Chilli Powder.jpg';

function OrderPage() {
    const { category } = useParams();
    const navigate = useNavigate();
    const [quantity, setQuantity] = useState(1);
    const [selectedType, setSelectedType] = useState('');
    const [packWeight, setPackWeight] = useState('');
    const [selectedUnit, setSelectedUnit] = useState('kg');
    const [email, setEmail] = useState(localStorage.getItem('customerEmail') || '');
    const [mainImage, setMainImage] = useState(placeholderImage);

    const categories = {
        'cinnamon': {
            name: 'Cinnamon Products of Galle Ceylon Spices',
            description: 'Ceylon Cinnamon was highly prized for centuries mainly due to its delicate flavour. Discerning cuisines of the modern world still seek Ceylon Cinnamon despite it being more expensive than the more common varieties of Cinnamon freely available in the international market.',
            types: [
                { name: 'Cinnamon Off Cut', image: cinnamonOffCutImage },
                { name: 'Cinnamon Quillings No. 02', image: cinnamonQuillingsImage },
                { name: 'Cinnamon H1', image: cinnamonH1Image },
                { name: 'Cinnamon H2', image: cinnamonH2Image },
                { name: 'Cinnamon H2 Super', image: cinnamonH2SuperImage },
                { name: 'Cinnamon M4', image: cinnamonM4Image },
                { name: 'Cinnamon M5', image: cinnamonM5Image },
                { name: 'Cinnamon C4', image: cinnamonC4Image },
                { name: 'Cinnamon C5', image: cinnamonC5Image },
                { name: 'Cinnamon C5 Special', image: cinnamonC5SpecialImage },
                { name: 'Cinnamon Extra Special', image: cinnamonExtraSpecialImage },
                { name: 'Cinnamon Alba', image: cinnamonAlbaImage },
                { name: 'Cinnamon Leaf Oil', image: cinnamonLeafOilImage },
                { name: 'Cinnamon Powder', image: cinnamonPowderImage }
            ],
        },
        'whole-spices': {
            name: 'Whole Spices of Galle Ceylon Spices',
            description: 'Our Whole Spices collection brings the authentic flavors of Sri Lanka to your kitchen. Sourced from the finest estates, these spices offer robust aromas and tastes that elevate any dish.',
            types: [
                { name: 'Black Pepper', image: blackPepperImage },
                { name: 'Nutmeg', image: nutmegImage },
                { name: 'Cloves', image: clovesImage },
                { name: 'Mace', image: maceImage },
                { name: 'Betel Nuts', image: betelNutsImage },
                { name: 'Dehydrated Green Pepper', image: dehydratedGreenPepperImage },
                { name: 'White Pepper', image: whitePepperImage },
                { name: 'Clove Stems', image: cloveStemsImage },
                { name: 'Turmeric', image: turmericImage }
            ],
        },
        'spice-powder': {
            name: 'Spice Powders of Galle Ceylon Spices',
            description: 'Our Spice Powders are finely ground from the best Sri Lankan spices, delivering intense flavors and aromas. Perfect for seasoning and cooking, they bring authenticity to every meal.',
            types: [
                { name: 'Black Pepper Powder', image: blackPepperPowderImage },
                { name: 'Nutmeg Powder', image: nutmegPowderImage },
                { name: 'White Pepper Powder', image: whitePepperPowderImage },
                { name: 'Ginger Powder', image: gingerPowderImage },
                { name: 'Clove Powder', image: clovePowderImage },
                { name: 'Turmeric Powder', image: turmericPowderImage },
                { name: 'Chili Powder', image: chiliPowderImage }
            ],
        }
    };

    const product = categories[category] || { name: 'Product Not Found', description: '', types: [] };
    const defaultType = product.types.length > 0 ? product.types[0].name : '';

    useEffect(() => {
        if (!selectedType && defaultType) {
            setSelectedType(defaultType);
            const initialType = product.types.find(type => type.name === defaultType);
            setMainImage(initialType ? initialType.image : placeholderImage);
        }
    }, [defaultType, product.types, selectedType]);

    useEffect(() => {
        const selected = product.types.find(type => type.name === selectedType);
        setMainImage(selected ? selected.image : placeholderImage);
    }, [selectedType, product.types]);

    const handleQuantityChange = (change) => {
        setQuantity(prev => Math.max(1, prev + change));
    };

    const handleAddToQuote = async () => {
        if (!packWeight || !selectedType || !email) {
            alert('Please select a product type, enter a pack weight, and provide your email.');
            return;
        }

        // Validate email format
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            alert('Please enter a valid email address.');
            return;
        }

        // Validate pack weight
        const weight = Number(packWeight);
        if (isNaN(weight) || weight <= 0) {
            alert('Please enter a valid pack weight greater than 0.');
            return;
        }

        // Save email to localStorage
        localStorage.setItem('customerEmail', email);

        const cartItem = {
            category: category.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase()),
            type: selectedType,
            quantity: Number(quantity),
            packWeight: String(packWeight),
            unit: selectedUnit,
            email: email
        };

        try {
            const response = await fetch('https://galleceylonspices.com/api/cart', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(cartItem),
            });

            if (response.ok) {
                navigate('/cart');
            } else {
                const errorData = await response.json();
                alert('Failed to add item to cart: ' + (errorData.error || 'Unknown error'));
            }
        } catch (error) {
            console.error('Error adding item to cart:', error);
            alert('An error occurred while adding the item to the cart. Please try again or contact support.');
        }
    };

    // SEO Structured Data
    const structuredData = {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": product.name,
        "description": product.description,
        "url": `https://www.galleceylonspices.com/order/${category}`,
        "image": mainImage,
        "brand": {
            "@type": "Brand",
            "name": "Galle Ceylon Spices International"
        },
        "offers": {
            "@type": "OfferCatalog",
            "name": `${product.name} Variants`,
            "itemListElement": product.types.map((type) => ({
                "@type": "Offer",
                "itemOffered": {
                    "@type": "Product",
                    "name": type.name,
                    "image": type.image,
                    "description": `Premium ${type.name} from Galle Ceylon Spices International`
                },
                "availability": "https://schema.org/InStock"
            }))
        },
        "publisher": {
            "@type": "Organization",
            "name": "Galle Ceylon Spices International (Pvt) Ltd",
            "logo": {
                "@type": "ImageObject",
                "url": "%PUBLIC_URL%/logo.png"
            },
            "address": {
                "@type": "PostalAddress",
                "streetAddress": "448/2, Nawadagala",
                "addressLocality": "Elpitiya",
                "postalCode": "80000",
                "addressCountry": "Sri Lanka"
            },
            "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+94-77-929-1829",
                "contactType": "Customer Service",
                "contactOption": "WhatsApp",
                "areaServed": "Worldwide",
                "availableLanguage": "English"
            }
        }
    };

    return (
        <div className="order-page-container my-4 py-4">
            <SEO
                title={`${product.name} - Galle Ceylon Spices International`}
                description={`Explore ${product.name.toLowerCase()} from Galle Ceylon Spices International. Select from premium variants like ${product.types.slice(0, 3).map(t => t.name).join(', ')} and add to your quote request.`}
                keywords={`${category.replace(/-/g, ' ')}, Ceylon spices, Galle Ceylon Spices, ${product.types.map(t => t.name.toLowerCase()).join(', ')}, Sri Lankan spices`}
                canonicalUrl={`https://www.galleceylonspices.com/order/${category}`}
                ogImage={mainImage}
                structuredData={structuredData}
            />
            <section className="animate__animated animate__fadeIn" style={{ animationDuration: '1s' }}>
                <div className="row g-4">
                    {/* Images Section */}
                    <div className="col-12 col-md-6">
                        <div className="mb-3 position-relative">
                            <img
                                src={mainImage}
                                alt={`${selectedType || product.name} main view`}
                                className="img-fluid rounded-3 shadow-sm transition-transform"
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    objectFit: 'contain',
                                    transition: 'transform 0.3s ease-in-out',
                                    maxHeight: 'clamp(300px, 50vw, 500px)',
                                }}
                                onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.05)')}
                                onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                loading="lazy"
                            />
                        </div>
                        <div className="bg-light p-2 rounded-3 shadow-sm border border-secondary-subtle d-flex flex-wrap gap-2" style={{ maxHeight: '150px', overflowY: 'auto' }}>
                            {product.types.map((type, index) => (
                                <img
                                    key={index}
                                    src={type.image}
                                    alt={`${type.name} thumbnail`}
                                    className={`rounded-3 transition-opacity ${selectedType === type.name ? 'border border-primary' : ''}`}
                                    style={{
                                        width: 'clamp(60px, 15vw, 80px)',
                                        height: 'clamp(60px, 15vw, 80px)',
                                        objectFit: 'cover',
                                        cursor: 'pointer',
                                        opacity: selectedType === type.name ? 1 : 0.7,
                                        transition: 'opacity 0.3s ease-in-out',
                                    }}
                                    onClick={() => setSelectedType(type.name)}
                                    loading="lazy"
                                    aria-label={`Select ${type.name} thumbnail`}
                                />
                            ))}
                        </div>
                    </div>

                    {/* Product Details Section */}
                    <div className="col-12 col-md-6 p-3 d-flex flex-column">
                        <h2
                            className="text-dark fw-bold mb-3"
                            style={{
                                fontSize: 'clamp(1.8rem, 4vw, 2.8rem)',
                                letterSpacing: '0.5px',
                                color: '#355E3B',
                                fontFamily: 'Georgia',
                                lineHeight: '1.2',
                            }}
                        >
                            {product.name}
                        </h2>
                        <p
                            className="text-muted mb-3 lead"
                            style={{
                                lineHeight: '1.8',
                                fontSize: 'clamp(1rem, 2.5vw, 1.2rem)',
                                color: '#666',
                            }}
                        >
                            {product.description}
                        </p>

                        {/* Email Input */}
                        <div className="mb-3">
                            <label htmlFor="emailInput" className="form-label fw-medium text-muted" style={{ fontSize: 'clamp(1rem, 2.5vw, 1.2rem)', color: '#555' }}>
                                Your Email
                            </label>
                            <input
                                id="emailInput"
                                type="email"
                                className="form-control rounded-3 shadow-sm"
                                placeholder="Enter your email address"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                style={{ borderColor: '#E6F0E6', padding: '10px', fontSize: 'clamp(0.9rem, 2vw, 1rem)', backgroundColor: '#F9F9F9' }}
                                required
                                aria-label="Email address for quote request"
                            />
                        </div>

                        {/* Available Type Dropdown */}
                        <div className="mb-3">
                            <label htmlFor="typeSelect" className="form-label fw-medium text-muted" style={{ fontSize: 'clamp(1rem, 2.5vw, 1.2rem)', color: '#555' }}>
                                Available Type
                            </label>
                            <select
                                id="typeSelect"
                                className="form-select rounded-3 shadow-sm"
                                value={selectedType}
                                onChange={(e) => setSelectedType(e.target.value)}
                                style={{ padding: '10px', fontSize: 'clamp(0.9rem, 2vw, 1.1rem)', borderColor: '#E6F0E6', backgroundColor: '#F9F9F9' }}
                                aria-label="Select product type"
                            >
                                <option value="" disabled>Select a type</option>
                                {product.types.map((type, index) => (
                                    <option key={index} value={type.name}>
                                        {type.name}
                                    </option>
                                ))}
                            </select>
                        </div>

                        {/* Pack Weight Input with Unit Selection */}
                        <div className="mb-3">
                            <label htmlFor="packWeightInput" className="form-label fw-medium text-muted" style={{ fontSize: 'clamp(1rem, 2.5vw, 1.2rem)', color: '#555' }}>
                                Pack Weight
                            </label>
                            <div className="input-group">
                                <input
                                    id="packWeightInput"
                                    type="number"
                                    className="form-control rounded-start-3 shadow-sm"
                                    placeholder="Enter pack weight"
                                    value={packWeight}
                                    onChange={(e) => setPackWeight(e.target.value)}
                                    min="0.1"
                                    step="0.1"
                                    style={{ borderColor: '#E6F0E6', padding: '10px', fontSize: 'clamp(0.9rem, 2vw, 1rem)', backgroundColor: '#F9F9F9' }}
                                    required
                                    aria-label="Pack weight"
                                />
                                <select
                                    className="form-select rounded-end-3 shadow-sm"
                                    value={selectedUnit}
                                    onChange={(e) => setSelectedUnit(e.target.value)}
                                    style={{ width: '100px', borderColor: '#E6F0E6', padding: '10px', fontSize: 'clamp(0.9rem, 2vw, 1rem)', backgroundColor: '#F9F9F9' }}
                                    aria-label="Select weight unit"
                                >
                                    <option value="kg">kg</option>
                                    <option value="ml">ml</option>
                                    <option value="l">l</option>
                                </select>
                            </div>
                        </div>

                        {/* Quantity Selector and Add to Quote Button */}
                        <div className="d-flex flex-column flex-md-row align-items-center mb-3 gap-3">
                            <div className="input-group" style={{ width: 'clamp(140px, 30vw, 160px)' }}>
                                <button
                                    className="btn btn-outline-secondary rounded-start-3"
                                    onClick={() => handleQuantityChange(-1)}
                                    style={{ borderColor: '#E6F0E6', padding: '8px 12px', fontSize: 'clamp(0.9rem, 2vw, 1.1rem)' }}
                                    aria-label="Decrease quantity"
                                >
                                    -
                                </button>
                                <span className="form-control text-center" style={{ borderColor: '#E6F0E6', padding: '8px', fontSize: 'clamp(1rem, 2.5vw, 1.2rem)', backgroundColor: '#F9F9F9' }}>
                                    {quantity}
                                </span>
                                <button
                                    className="btn btn-outline-secondary rounded-end-3"
                                    onClick={() => handleQuantityChange(1)}
                                    style={{ borderColor: '#E6F0E6', padding: '8px 12px', fontSize: 'clamp(0.9rem, 2vw, 1.1rem)' }}
                                    aria-label="Increase quantity"
                                >
                                    +
                                </button>
                            </div>
                            <button
                                className="btn text-white rounded-3 flex-grow-1"
                                style={{
                                    backgroundColor: '#C19A6B',
                                    padding: '12px 20px',
                                    fontSize: 'clamp(1rem, 2.5vw, 1.2rem)',
                                    transition: 'all 0.3s ease-in-out',
                                    boxShadow: '0 3px 8px rgba(0, 0, 0, 0.15)',
                                    fontFamily: 'Georgia',
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.backgroundColor = '#A67B4D';
                                    e.currentTarget.style.boxShadow = '0 5px 15px rgba(0, 0, 0, 0.25)';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.backgroundColor = '#C19A6B';
                                    e.currentTarget.style.boxShadow = '0 3px 8px rgba(0, 0, 0, 0.15)';
                                }}
                                onClick={handleAddToQuote}
                                aria-label="Add to quote request"
                            >
                                Add To Quote Request
                            </button>
                        </div>

                        {/* Category */}
                        <div className="text-muted small mt-auto">
                            <span style={{ fontSize: 'clamp(0.8rem, 2vw, 1rem)', color: '#777' }}>
                                Category: {category.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
                            </span>
                        </div>
                    </div>
                </div>
            </section>

            {/* Inline CSS for responsiveness */}
            <style>
                {`
                    @media (max-width: 576px) {
                        .order-page-container {
                            padding-left: 0.5rem !important;
                            padding-right: 0.5rem !important;
                        }
                        .order-page-container.my-4 {
                            margin-top: 1rem !important;
                            margin-bottom: 1rem !important;
                        }
                        .order-page-container.py-4 {
                            padding-top: 1rem !important;
                            padding-bottom: 1rem !important;
                        }
                        .order-page-container .p-3 {
                            padding: 0.75rem !important;
                        }
                        .order-page-container .mb-3 {
                            margin-bottom: 0.5rem !important;
                        }
                        .order-page-container img.img-fluid {
                            max-height: 300px !important;
                        }
                        .order-page-container .bg-light {
                            max-height: 120px !important;
                            padding: 0.5rem !important;
                            gap: 0.5rem !important;
                        }
                        .order-page-container .input-group, .order-page-container .btn {
                            padding: 8px !important;
                        }
                        .order-page-container .form-select, .order-page-container .form-control {
                            padding: 6px !important;
                            font-size: 0.9rem !important;
                        }
                        .order-page-container .d-flex.flex-column.flex-md-row {
                            flex-direction: column !important;
                        }
                    }
                    @media (max-width: 576px) and (orientation: landscape) {
                        .order-page-container img.img-fluid {
                            max-height: 200px !important;
                        }
                        .order-page-container .bg-light {
                            max-height: 100px !important;
                            padding: 0.25rem !important;
                            gap: 0.25rem !important;
                        }
                        .order-page-container .p-3 {
                            padding: 0.5rem !important;
                        }
                        .order-page-container .input-group, .order-page-container .btn {
                            padding: 6px !important;
                        }
                        .order-page-container .form-select, .order-page-container .form-control {
                            padding: 4px !important;
                            font-size: 0.8rem !important;
                        }
                    }
                    @media (min-width: 577px) and (max-width: 768px) {
                        .order-page-container {
                            padding-left: 1rem !important;
                            padding-right: 1rem !important;
                        }
                        .order-page-container.my-4 {
                            margin-top: 2rem !important;
                            margin-bottom: 2rem !important;
                        }
                        .order-page-container.py-4 {
                            padding-top: 2rem !important;
                            padding-bottom: 2rem !important;
                        }
                        .order-page-container .p-3 {
                            padding: 1rem !important;
                        }
                        .order-page-container img.img-fluid {
                            max-height: 400px !important;
                        }
                        .order-page-container .bg-light {
                            max-height: 130px !important;
                            padding: 1rem !important;
                            gap: 1rem !important;
                        }
                        .order-page-container .input-group, .order-page-container .btn {
                            padding: 10px !important;
                        }
                    }
                    @media (min-width: 769px) and (max-width: 1024px) {
                        .order-page-container {
                            padding-left: 1.5rem !important;
                            padding-right: 1.5rem !important;
                        }
                        .order-page-container.my-4 {
                            margin-top: 3rem !important;
                            margin-bottom: 3rem !important;
                        }
                        .order-page-container.py-4 {
                            padding-top: 3rem !important;
                            padding-bottom: 3rem !important;
                        }
                        .order-page-container .p-3 {
                            padding: 1.5rem !important;
                        }
                        .order-page-container img.img-fluid {
                            max-height: 450px !important;
                        }
                        .order-page-container .bg-light {
                            max-height: 140px !important;
                            padding: 1.5rem !important;
                            gap: 1.5rem !important;
                        }
                    }
                    @media (min-width: 1025px) {
                        .order-page-container {
                            padding-left: 2rem !important;
                            padding-right: 2rem !important;
                        }
                        .order-page-container.my-4 {
                            margin-top: 4rem !important;
                            margin-bottom: 4rem !important;
                        }
                        .order-page-container.py-4 {
                            padding-top: 4rem !important;
                            padding-bottom: 4rem !important;
                        }
                        .order-page-container .p-3 {
                            padding: 2rem !important;
                        }
                        .order-page-container img.img-fluid {
                            max-height: 500px !important;
                        }
                        .order-page-container .bg-light {
                            max-height: 150px !important;
                            padding: 2rem !important;
                            gap: 2rem !important;
                        }
                    }
                `}
            </style>
        </div>
    );
}

export default OrderPage;